import { ICandidateResponseOption } from "./candidate-response-option.model";
import { IResourceToInstance } from "./resource-to-instance.model";
import { ICandidate } from "./candidate.model";
import { IApplication } from "./application.model";
import { CandidateResource } from "./enumerations/candidate-resource.model";

export interface ICandidateToResourceInstance {
  id?: number;
  state?: CandidateResource | null;
  link?: string;
  valuation?: string;
  candidateResponeOptions?: ICandidateResponseOption[] | null;
  resourceToInstance?: IResourceToInstance | null;
  candidate?: ICandidate | null;
  application?: IApplication | null;
  isCompletedResource?: boolean | null;
  isInvalidToken?: boolean | null;
  message?: string;
}

export const defaultValue: Readonly<ICandidateToResourceInstance> = {};
